var map = {
	"./berlin.svg": 2008,
	"./bielefeld.svg": 5899,
	"./bremerhaven.svg": 631,
	"./de.svg": 2170,
	"./en.svg": 7456,
	"./leaves_left.svg": 7129,
	"./leaves_right.svg": 5239,
	"./nrw.svg": 7783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;